import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import Spinner from 'lib/tags/spinner'
import Tooltip from 'rc-tooltip'

import ReputationData from 'lib/components/reputation-data'

import controller from '../../controller.rb'

function Reputation (props) {
  const [loaded, setLoaded] = useState(false)
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState(null)

  const _isMounted = useRef(false)

  const { id, className } = props

  let overlay

  useEffect(() => {
    _isMounted.current = true

    return () => {
      _isMounted.current = false
    }
  }, [id, loading, loaded, data])

  const onVisibleChange = () => {
    if (!loaded && !loading) {
      setLoaded(true)

      controller.reputation({ id }).then(response => {
        if (_isMounted) {
          setLoaded(true)
          setLoading(false)
          setData(response)
        }
      })
    }
  }

  if (data && !data.error) {
    overlay = (
      <div style={{ margin: '5px 5px 0px 5px' }}>
        <ReputationData data={data} />
      </div>
    )
  } else if (data && data.error) {
    overlay = <div>Error: {data.error}</div>
  } else {
    overlay = <Spinner />
  }

  return (
    <Tooltip placement='right' trigger={['hover']} onVisibleChange={onVisibleChange} overlay={overlay}>
      <div className={className || 'reputation-badge'} />
    </Tooltip>
  )
}

Reputation.propTypes = {
  id: PropTypes.number,
  className: PropTypes.string
}

export default React.memo(Reputation)
